export const sanitizeHtmlForRender = (html) => {
  if (!html || typeof html !== 'string') return '';
  if (typeof window === 'undefined' || !window.document) return html;

  const template = document.createElement('template');
  template.innerHTML = html;

  // Remove dangerous nodes entirely.
  template.content.querySelectorAll('script, style, iframe, object, embed, link, meta').forEach((el) => el.remove());

  // Remove dangerous attributes and javascript: URLs.
  template.content.querySelectorAll('*').forEach((el) => {
    [...el.attributes].forEach((attr) => {
      const name = attr.name.toLowerCase();
      const value = (attr.value || '').trim().toLowerCase();
      if (name.startsWith('on') || value.startsWith('javascript:') || value.startsWith('data:text/html')) {
        el.removeAttribute(attr.name);
      }
    });
  });

  return template.innerHTML;
};

